// Direct GCS URLs for images: edge-cached (~0.2s) vs the Firebase wrapper (~1s, uncached).
// Bucket is public-read. Used as primary <img> src with the wrapper URL as @error fallback.

const bucket = () => process.env.VUE_APP_FIREBASE_STORAGE_BUCKET

// imageRef -> https://storage.googleapis.com/{bucket}/{encoded path}. Returns '' if no ref.
export function directGcsUrl(imageRef) {
  const BUCKET = bucket()
  if (!imageRef || !BUCKET) return ''
  const path = imageRef.split('/').map(encodeURIComponent).join('/')
  return `https://storage.googleapis.com/${BUCKET}/${path}`
}

// Thumb variant: work thumbnails are stored at `{imageRef}_thumb`.
export function directGcsThumbUrl(imageRef) {
  const base = directGcsUrl(imageRef)
  return base ? base + '_thumb' : ''
}

// Thumb URL the grid renders (direct GCS when derivable) - prefetchers must warm the same URL.
export function bestThumbUrl(work) {
  const wrapper = work.thumbnailUrl || work.imageThumb || ''
  const direct = work.imageRef ? directGcsThumbUrl(work.imageRef) : wrapperToDirectUrl(wrapper)
  return direct || wrapper
}

// Wrapper URL -> direct GCS URL, for images that store only the wrapper (no imageRef).
// Returns '' if not a recognizable wrapper URL.
export function wrapperToDirectUrl(wrapperUrl) {
  const BUCKET = bucket()
  if (!wrapperUrl || !BUCKET) return ''
  const m = /\/o\/([^?]+)/.exec(wrapperUrl)
  if (!m) return ''
  const path = decodeURIComponent(m[1]) // the stored path, then re-encode per segment
  const enc = path.split('/').map(encodeURIComponent).join('/')
  return `https://storage.googleapis.com/${BUCKET}/${enc}`
}
